var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "detail-summay-containter",
      attrs: { id: "detail-summay-content" },
    },
    [
      _c(
        "ul",
        {
          staticClass: "accordion",
          attrs: {
            id: "detail-summay-accordion",
            "data-accordion": "",
            "data-deep-link": "true",
            "data-allow-all-closed": "true",
            "data-multi-expand": "true",
            "data-update-history": "true",
            "data-deep-link-smudge": "500",
          },
        },
        [
          _c(
            "li",
            {
              staticClass: "accordion-item is-active",
              attrs: { "data-accordion-item": "" },
            },
            [
              _c(
                "a",
                {
                  staticClass: "accordion-title",
                  attrs: { href: "#detail-summary-tabs" },
                },
                [_c("span", [_vm._v(_vm._s(_vm.$t("tender.detail")))])]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "accordion-content",
                  attrs: { id: "detail-summary-tabs", "data-tab-content": "" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "row detail-options" },
                    [
                      _c("HKLSelect", {
                        staticClass: "item-selector column small-5",
                        attrs: {
                          value: _vm.viewUser ? _vm.viewUser.id : undefined,
                          options: _vm.viewUserHklOptions,
                          showSearch: false,
                          placeholder: "",
                        },
                        on: { change: _vm.onViewUserChange },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "column small-4 tender-detail-btns" },
                        [
                          _c(
                            "div",
                            { staticClass: "row align-right" },
                            [
                              _vm.shouldShowExportPdf
                                ? _c("ExportPdfWithOptions", {
                                    attrs: { options: _vm.exportOptions },
                                    on: {
                                      "export:pdf": function (val) {
                                        return _vm.exportPDF(val)
                                      },
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.showQueryBtn,
                                      expression: "showQueryBtn",
                                    },
                                  ],
                                  staticClass: "btn btn--darkblue",
                                  attrs: {
                                    role: "start-query-button",
                                    type: "button",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.startQuery()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("action.startQuery")) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { attrs: { id: "detail-list" } },
                    [
                      _c("tender", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.viewUser && _vm.viewUser.isEngineer,
                            expression: "viewUser&&viewUser.isEngineer",
                          },
                        ],
                      }),
                      _vm._v(" "),
                      _vm.showBid
                        ? _c("bid", { ref: "bidComponent" })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }